import { concatIf } from '@btime/helpers'
import { head } from 'ramda'
import { useFilter } from '@btime/react-contexts'
import React from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { useGenericState } from '../../../../packages/kiti/components/helpers/GenericState'
import Dropdown from '../../../../packages/kiti/components/navigation/Dropdown'

// Função auxiliar que pode ser usada fora de componentes React
export const getPerspectiveOptions = (date, t) => {
  let [init, end] = date || []
  if (!init || !end) return []

  init = moment(init)
  end = moment(end)
  const hours = end.diff(init, 'hours')
  const days = end.diff(init, 'days')
  const months = end.diff(init, 'months')

  return [
    ...concatIf(days <= 3, [{ id: 'hour', name: t('widgets.byHour') }]),
    ...concatIf(days <= 60 && hours >= 47, [{ id: 'day', name: t('widgets.byDay') }]),
    ...concatIf(months <= 22 && days >= 56, [{ id: 'month', name: t('widgets.byMonth') }]),
    ...concatIf(months >= 23, [{ id: 'year', name: t('widgets.byYear') }])
    // { id: 'week', name: 'Por semana', disabled: true }
    // { id: 'trimester', name: 'Por trimestre' },
    // { id: 'semester', name: 'Por semestre' },
  ]
}

export const useGetPerspectiveOptions = () => {
  const { t } = useTranslation('common')
  const filter = useFilter() || {}
  const date = filter.date || []

  return getPerspectiveOptions(date, t)
}

export const usePerspectiveOptions = () => {
  return useGetPerspectiveOptions()
}

export const useSelectedPerspective = () => {
  const { value } = useGenericState()
  const options = usePerspectiveOptions()
  return value?.perspective || head(options)
}

const PerspectiveDropdown = () => {
  const { t } = useTranslation('common')
  const { handleChange } = useGenericState()
  const perspective = useSelectedPerspective()

  const options = usePerspectiveOptions()

  // React.useEffect(() => {
  // handleChange('perspective', options.find(propEq('id', perspective.id)) || head(options))
  // }, [filter.date])

  return (
    <Dropdown
      label={perspective?.name || t('widgets.perspective')}
      onChange={handleChange('perspective')}
      options={options}
      placement="bottomRight"
    />
  )
}

export default PerspectiveDropdown
